import { NgApiClient } from '@src/api/ngApiClient';
import { TDevelopmentMode } from './models';

export const getDevelopmentMode = (client: NgApiClient): TDevelopmentMode | undefined => {
  const apiUrl = client.configUrls.api;
  const devUrl = 'api.dev.centra.ai';
  const stageUrl = 'api.stage.centra.ai';
  const prodUrl = 'api.centra.ai';

  if (!apiUrl || typeof apiUrl !== 'string') return undefined;

  if (apiUrl.includes(devUrl)) return 'dev';
  if (apiUrl.includes(stageUrl)) return 'stage';
  if (apiUrl.includes(prodUrl)) return 'prod';

  return undefined;
};
